import React, { useEffect, useState } from 'react';

import ChoiceLine from './../form-wrappers/choice-line';
import IntervalItem from './../form-items/interval-item';

const IntervalChoice = ({ suffix, choiceObj }) => {
  const [currentSuffix, setCurrentSuffix] = useState(null);

  useEffect(() => {
    setCurrentSuffix(suffix);
  }, suffix);

  const onChangeInterval = (value) => {
    if (value && value === 1) {
      const stringSuffix = suffix.substring(0, suffix.length - 3);
      setCurrentSuffix(stringSuffix);
    } else {
      setCurrentSuffix(suffix);
    }
  };

  return (
    <ChoiceLine
      suffix={currentSuffix}
      sizes={choiceObj.sizes}
      prefix={{ isRadioGroup: choiceObj.isRadioGroup, label: 'Every', value: choiceObj.choiceLineValue }}
    >
      <IntervalItem
        onChange={onChangeInterval}
        selectedChoice={choiceObj.selectedChoice}
        choiceLineValue={choiceObj.choiceLineValue}
        requiredItems={choiceObj.requiredItems}
        isRadioGroup={choiceObj.isRadioGroup}
      />
    </ChoiceLine>
  );
};
export default IntervalChoice;
